import { MinusCircleOutlined } from '@ant-design/icons';
import { Flex } from '@revenuemarket/cds';
import { Colors, typographyStyle } from '@revenuemarket/design';
import { Typography } from 'antd';
import { GroupTreeItem } from '~apis/custom-label';
import HorizontalTreeTable from '~components/ui/HorizontalTreeTable';

import { TreeTableProps } from './types';

interface Props extends TreeTableProps<GroupTreeItem> {}

const GroupLabelTreeTable: React.FC<Props> = ({
  setActiveItem,
  activeItem,
  foldedAll,
  treeData,
}) => {
  return (
    <HorizontalTreeTable<GroupTreeItem>
      cellRenderer={(item) => {
        return (
          <Flex>
            <Typography.Text
              ellipsis
              style={{
                color: Colors.gray800,
                ...typographyStyle['13_400'],
                width: item?.value?.isActive === false ? 95 : 120,
              }}
            >
              {item?.value?.label || item?.value?.name}
            </Typography.Text>
            {item?.value?.isActive === false ? (
              <MinusCircleOutlined
                width={18}
                height={18}
                style={{
                  color: Colors.gray400,
                }}
              />
            ) : null}
          </Flex>
        );
      }}
      filterCondition={() => {
        return true;
      }}
      treeData={treeData}
      foldedAll={foldedAll}
      updatedFocusedId={activeItem?.key}
      onCellClick={(result) => {
        setActiveItem(result);
      }}
      onCellClear={() => {
        setActiveItem(undefined);
      }}
    />
  );
};

export default GroupLabelTreeTable;
